module.exports = __webpack_public_path__ + "static/empty-resources-31656a99f8a44f80bb0c4475199bfdaf.svg";